"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sbtDependencyGraphPluginNameNew = exports.sbtDependencyGraphPluginName = exports.sbtCoursierPluginName = void 0;
exports.sbtCoursierPluginName = 'sbt-coursier';
exports.sbtDependencyGraphPluginName = 'sbt-dependency-graph';
exports.sbtDependencyGraphPluginNameNew = 'addDependencyTreePlugin';
//# sourceMappingURL=constants.js.map